import React, { FC, useEffect, useState } from 'react';
import { Button, Container, Link, Stack } from '@mui/material';
import { Field, Form } from 'react-final-form';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import NumberFormatTelAdapter from '../components/NumberFormat/NumberFormatTelAdapter';
import {
  composeValidators,
  parseNumber,
  validateNumber,
  validateRequired,
  validateTel,
} from '../helpers/ValidatorHelper';
import TextFieldAdapter from '../components/FinalFormAdapters/TextFieldAdapter';
import { requestAllAccountTokens } from '../api/auth';
import useClosableSnackbar from '../hooks/useClosableSnackbar';
import SmsSender from '../components/SmsSender';
import { CodeValidatedActionEnum } from '../enum/CodeValidatedActionEnum';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import Footer from '../layout/Footer';
import useCheckAuth from '../hooks/useCheckAuth';
import { AccountPurpose } from '../enum/AccountPurpose';

interface SignInFormValues {
  code: string;
  phone: string;
}

const SignIn: FC = () => {
  const [processing, setProcessing] = useState<boolean>(false);
  const { showSnackbar } = useClosableSnackbar();
  const navigate = useNavigate();
  const checkAuth = useCheckAuth();

  useEffect(() => {
    checkAuth();
  }, []);

  const submit = async ({ code, phone }: SignInFormValues) => {
    setProcessing(true);
    try {
      const r = await requestAllAccountTokens(`7${parseNumber(phone)}`, code);
      const accounts = r.filter((v) => v.purpose === AccountPurpose.AGENT);
      if (Array.isArray(accounts) && accounts.length) {
        localStorage.setItem('user', JSON.stringify(accounts[0]));
        navigate('/');
      } else {
        showSnackbar('Активные аккаунты не найдены');
        console.log('no accounts'); // todo: remove this line
      }
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    setProcessing(false);
  };

  return (
    <>
      <ResponsiveAppBar title="Авторизация в агентском кабинете" />
      <Container
        maxWidth="lg"
        style={{ textAlign: 'center', minHeight: 'calc(100vh - 78px)' }}
      >
        <Grid2
          container
          spacing={2}
          justifyContent="center"
          height="100%"
          alignItems="center"
          style={{ minHeight: 'calc(100vh - 78px)' }}
        >
          <Grid2
            xs={12}
            flexDirection="row"
            alignItems="center"
            style={{ maxWidth: '500px', marginTop: '40px' }}
          >
            <Form
              onSubmit={submit}
              render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <Field
                    variant="outlined"
                    type="tel"
                    required
                    label="Телефон"
                    fullWidth
                    margin="normal"
                    name="phone"
                    validate={composeValidators(validateTel, validateRequired)}
                    component={NumberFormatTelAdapter}
                    maxLength={10}
                  />
                  {Boolean(values.phone) && (
                    <div style={{ marginTop: '1.5rem' }}>
                      <SmsSender
                        format="(###) ### ## ##"
                        prefix="+7 "
                        phone={parseNumber(values.phone)}
                        action={
                          CodeValidatedActionEnum.REQUEST_ALL_ACCOUNT_TOKENS
                        }
                      />
                      <Field
                        sx={{ mt: 3 }}
                        variant="outlined"
                        label="Код подтверждения"
                        fullWidth
                        margin="dense"
                        name="code"
                        validate={composeValidators(
                          validateRequired,
                          validateNumber
                        )}
                        component={TextFieldAdapter}
                      />
                    </div>
                  )}
                  <Button
                    size="large"
                    disabled={processing}
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3 }}
                  >
                    Войти
                  </Button>
                  <Stack style={{ marginTop: '1rem' }}>
                    <Link to="/signUp" component={RouterLink}>
                      Зарегистрироваться
                    </Link>
                    <Link href="/lk/index.html#/signUp/borrower">
                      Зарегистрироваться как заёмщик
                    </Link>
                    <Link href="/lk/index.html#/signUp/investor">
                      Зарегистрироваться как инвестор
                    </Link>
                  </Stack>
                </form>
              )}
            />
          </Grid2>
        </Grid2>
      </Container>
      <Footer />
    </>
  );
};

export default SignIn;
